/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Point_CitationInputs */

const en_directory_hubs_signals_geo_point_citation = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI answers cite pages that are fetchable, parseable, and fact-dense. Each failed check is a reason an engine picked a competitor's page instead.`)
};

const zh_directory_hubs_signals_geo_point_citation = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 答案引用的是可抓取、可解析、事实密度高的页面。每一个失败项，都是引擎选择竞争对手页面的理由。`)
};

/**
* | output |
* | --- |
* | "AI answers cite pages that are fetchable, parseable, and fact-dense. Each failed check is a reason an engine picked a competitor's page instead." |
*
* @param {Directory_Hubs_Signals_Geo_Point_CitationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_point_citation = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Point_CitationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Point_CitationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_point_citation(inputs)
	return zh_directory_hubs_signals_geo_point_citation(inputs)
});
export { directory_hubs_signals_geo_point_citation as "directory.hubs.signals.geo.point.citation" }